// ---- Horizontal menu scroller ----
const $menu = document.querySelector('.menu');
if ($menu) {
  const $items = $menu.querySelectorAll('.menu--item');
  const $images = $menu.querySelectorAll('.menu--item img');
  if ($items.length) {
    let menuWidth = $menu.clientWidth;
    let itemWidth = $items[0].clientWidth;
    let wrapWidth = $items.length * itemWidth;

    let scrollSpeed = 0;
    let oldScrollY = 0;
    let scrollY = 0;
    let y = 0;

    const lerp = (v0, v1, t) => v0 * (1 - t) + v1 * t;
    const dispose = (scroll) => {
      gsap.set($items, { x: (i) => i * itemWidth + scroll });
    };
    dispose(0);

    const handleMouseWheel = (e) => { scrollY -= e.deltaY * 0.9; };

    // Wheel (prevent only when we can scroll the rail)
    $menu.addEventListener('wheel', function (e) {
      const maxScroll = -(wrapWidth - menuWidth);
      const nextScroll = scrollY - e.deltaY * 0.9;
      if (nextScroll <= 0 && nextScroll >= maxScroll) {
        e.preventDefault();
        handleMouseWheel(e);
      }
    }, { passive: false });

    // Touch/drag
    let touchStart = 0, touchX = 0, isDragging = false;
    const handleTouchStart = (e) => {
      touchStart = e.clientX || e.touches[0].clientX;
      isDragging = true;
      $menu.classList.add('is-dragging');
    };
    const handleTouchMove = (e) => {
      if (!isDragging) return;
      touchX = e.clientX || e.touches[0].clientX;
      scrollY += (touchX - touchStart) * 2.5;
      touchStart = touchX;
    };
    const handleTouchEnd = () => { isDragging = false; $menu.classList.remove('is-dragging'); };

    $menu.addEventListener('touchstart', handleTouchStart);
    $menu.addEventListener('touchmove', handleTouchMove);
    $menu.addEventListener('touchend', handleTouchEnd);
    $menu.addEventListener('mousedown', handleTouchStart);
    $menu.addEventListener('mousemove', handleTouchMove);
    $menu.addEventListener('mouseleave', handleTouchEnd);
    $menu.addEventListener('mouseup', handleTouchEnd);
    $menu.addEventListener('selectstart', () => false);

    window.addEventListener('resize', () => {
      menuWidth = $menu.clientWidth;
      itemWidth = $items[0].clientWidth;
      wrapWidth = $items.length * itemWidth;
    });

    const render = () => {
      requestAnimationFrame(render);
      y = lerp(y, scrollY, 0.1);
      const maxScroll = -(wrapWidth - menuWidth);
      scrollY = Math.max(Math.min(scrollY, 0), maxScroll);
      dispose(y);
      scrollSpeed = y - oldScrollY;
      oldScrollY = y;
    };
    render();
  }
}

// ---- rm-media-text-modular vertical scroll slider (guarded) ----
if (window.gsap) { gsap.registerPlugin(ScrollTrigger); }

(function(){
  // stop desktop GSAP on mobile/tablet
  if (!window.matchMedia('(min-width: 992px)').matches) return;
  const scrollSection = document.querySelector('.scroll-section');
  const imagesContainer = document.querySelector('.images');

  // Only run if this module exists on the page
  if (!scrollSection || !imagesContainer) return;

  const images = imagesContainer.querySelectorAll('img');
  if (!images.length) return;

  const slideIndicator = document.getElementById('active-slide-index');
  const totalScrollHeight = images.length * window.innerHeight;

  gsap.to(imagesContainer, {
    y: () => `-${totalScrollHeight - window.innerHeight}px`,
    ease: 'none',
    scrollTrigger: {
      trigger: scrollSection,
      start: 'top top',
      end: () => `+=${totalScrollHeight}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
    }
  });

  const texts = document.querySelectorAll('.left-column .text-item');
  function showText(index) {
    texts.forEach((t, i) => t.classList.toggle('active', i === index));
    if (slideIndicator) slideIndicator.textContent = String(index + 1).padStart(2, '0');
  }

  images.forEach((img, i) => {
    ScrollTrigger.create({
      trigger: img,
      start: 'center center',
      end: 'bottom center',
      onEnter: () => showText(i),
      onEnterBack: () => showText(i),
    });
  });
})();

/* Mobile slider for rm media with text half section */
// Mobile touch slider for .scroll-section.rm-slider (≤ 991px)
// Mobile full-slide touch carousel for .scroll-section.rm-touch
(function () {
  const SELECTOR = '.scroll-section.rm-touch';
  const sections = Array.from(document.querySelectorAll(SELECTOR));
  if (!sections.length) return;

  const mql = window.matchMedia('(max-width: 991px)');

  function build(section){
    if (section.__built) return;
    section.__built = true;

    // original sources
    const left  = section.querySelector('.left-column');
    const right = section.querySelector('.right-column .images_mob');
    if (!left || !right) return;

    const texts = Array.from(left.querySelectorAll('.text-item'));
    const imgs  = Array.from(right.querySelectorAll('img'));
    const n = Math.min(texts.length, imgs.length);
    if (!n) return;

    // viewport + track
    const viewport = document.createElement('div');
    viewport.className = 'rm-viewport-cc';
    const track = document.createElement('div');
    track.className = 'rm-track';
    viewport.appendChild(track);

    // build slides (move nodes so desktop stays lean; we restore later)
    const movedTexts = [], movedImgs = [];
    for (let i = 0; i < n; i++) {
      const slide = document.createElement('div');
      slide.className = 'rm-slide';

      const tWrap = document.createElement('div');
      tWrap.className = 'rm-slide-text';
      tWrap.appendChild(texts[i]);        // move
      movedTexts.push(texts[i]);

      const imgWrap = document.createElement('div');
      imgWrap.className = 'rm-slide-image';
      imgWrap.appendChild(imgs[i]);       // move
      movedImgs.push(imgs[i]);

      // counter overlay 01, 02, ...
      const counter = document.createElement('span');
      counter.className = 'rm-counter';
      counter.textContent = String(i + 1).padStart(2, '0');
      //imgWrap.appendChild(counter);

      slide.appendChild(imgWrap);
      slide.appendChild(tWrap);
      track.appendChild(slide);
    }

    // dots bar
    const dotsbar = document.createElement('div');
    dotsbar.className = 'rm-dotsbar';
    const dots = Array.from({ length: n }, (_, i) => {
      const d = document.createElement('span');
      d.className = 'rm-dot' + (i === 0 ? ' is-active' : '');
      d.addEventListener('click', () => goTo(i));
      dotsbar.appendChild(d);
      return d;
    });

    // hide original columns, mount viewport + dots
    left.style.display = 'none';
    section.querySelector('.right-column').style.display = 'none';
    section.appendChild(viewport);
    //section.appendChild(dotsbar);

    // helpers
    function setActive(i){
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      // ensure only one text-item is "active" (keeps your styles consistent)
      const items = viewport.querySelectorAll('.rm-slide-text .text-item');
      items.forEach((el, idx) => el.classList.toggle('active', idx === i));
    }
    function idx(){ return Math.round((viewport.scrollLeft || 0) / (viewport.clientWidth || 1)); }
    function goTo(i){
      viewport.scrollTo({ left: i * (viewport.clientWidth || 0), behavior: 'smooth' });
      setActive(i);
    }

    // sync on scroll (throttled)
    let ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { setActive(idx()); ticking = false; });
    }
    //viewport.addEventListener('scroll', onScroll, { passive: true });
    setActive(0);

    // teardown: put everything back for desktop
    section.__destroy = () => {
      viewport.removeEventListener('scroll', onScroll);
      dotsbar.remove();
      viewport.remove();

      // restore original structure
      const leftCol  = section.querySelector('.left-column');
      const rightCol = section.querySelector('.right-column .images');
      movedTexts.forEach(node => leftCol.appendChild(node));
      movedImgs.forEach(node => rightCol.appendChild(node));
      section.querySelector('.right-column').style.display = '';
      leftCol.style.display = '';
      section.__built = false;
    };
  }

  function destroy(section){ if (section.__destroy) section.__destroy(); }

  function apply(){
    sections.forEach(sec => mql.matches ? build(sec) : destroy(sec));
  }
  if (mql.addEventListener) mql.addEventListener('change', apply);
  else mql.addListener(apply);
  apply();

  // After images load, ensure layout is correct
  window.addEventListener('load', () => sections.forEach(sec => {
    if (!sec.__built) return;
    const vp = sec.querySelector('.rm-viewport');
    vp && vp.dispatchEvent(new Event('scroll'));
  }), { once: true });
})();
